import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { StorageService } from 'src/app/_services/storage.service';
import { environment } from 'src/environments/environment';
import { apiCategories } from 'src/app/_helpers/apiCategorize';

const API_URL = environment.API_URL;
const API_URLBLAZE = environment.API_URLBLAZE;

@Injectable({
  providedIn: 'root'
})
export class UserActivityService {

  constructor(private http: HttpClient, private storageService: StorageService, private router: Router) { }

  /**
   * Get user activity logs with pagination and filtering
   * @param filters Filter parameters for the activity logs
   * @param pageSize Number of records per page
   * @param pageNumber Current page number (0-based)
   * @returns Observable with activity log data
   */
  getUserActivityLogs(filters: any, pageSize: number, pageNumber: number): Observable<any> {
  //  let url = `http://localhost:9998crash-report/crash-report/shield-activity-log/report?size=${pageSize}&page=${pageNumber}`;
    let url = `${API_URLBLAZE}/crash-report/shield-activity-log/report?size=${pageSize}&page=${pageNumber}`;
    // Add filters to the URL if they exist
    if (filters) {
      if (filters.user && filters.user !== '') {
        url += `&user=${filters.user}`;
      }
      if (filters.category && filters.category !== '') {
        url += `&category=${filters.category}`;
      }
      if (filters.startDate && filters.startDate !== '') {
        // Format the date to match the required pattern: 2025-05-29T07:00:58.672+00:00
        const startDate = new Date(filters.startDate);
        url += `&startDate=${startDate.toISOString()}`;
      }
      if (filters.endDate && filters.endDate !== '') {
        // Format the date to match the required pattern: 2025-05-29T07:00:58.672+00:00
        const endDate = new Date(filters.endDate);
        url += `&endDate=${endDate.toISOString()}`;
      }
      if (filters.method && filters.method !== '') {
        url += `&method=${filters.method}`;
      }
    }
    
    console.log('Final API URL:', url);
    return this.http.get(url).pipe(catchError(this.handleError()));
  }

  /**
   * Get users for activity log filtering
   * @returns Observable with users data
   */
  getActivityUsers(): Observable<any> {
  //  const url = `http://localhost:9998/crash-report/shield-activity-log/users`;
    const url = `${API_URLBLAZE}/crash-report/shield-activity-log/users`;
    return this.http.get(url).pipe(catchError(this.handleError()));
  }

  /**
   * Get categories for activity log filtering from local apiCategories
   * @returns Observable with categories data
   */
  getActivityCategories(): Observable<any> {
    // Extract unique categories from apiCategories
    const categories = [...new Set(Object.values(apiCategories).map(item => item.category))];
    return of({ data: categories });
  }

  /**
   * Error handler for HTTP requests
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: HttpErrorResponse): Observable<T> => {
      if (error.status === 401) {
        this.storageService.clean();
        this.router.navigate(['/auth/login']);
      }
      console.error(`${operation} failed: ${error.message}`);
      result = error?.error;
      return of(result as T);
    };
  }
}